module.exports = __webpack_public_path__ + "static/media/taiwushan2.1172bcc5.jpg";